import axios from "axios";

function getSearchResults(
  salesOrg,
  distributionChannel,
  division,
  productHierarchies,
  query,
  strict
) {
  if (!division || !Array.isArray(division)) {
    division = [];
  }
  if (!productHierarchies || !Array.isArray(productHierarchies)) {
    productHierarchies = [];
  }
  const filters = [];
  if (strict) {
    filters.push("material_number eq '" + query + "'");
  } else {
    filters.push(
      "(substringof('" +
        query +
        "', material_number) eq true or substringof('" +
        query +
        "', material_description) eq true)"
    );
  }
  filters.push("sales_organization eq '" + salesOrg + "'");
  filters.push("distribution_channel eq '" + distributionChannel + "'");
  if (division.length) {
    filters.push(`(division eq '${division.join("' or division eq '")}')`);
  }
  if (productHierarchies.length) {
    filters.push(
      `(product_hierarchy eq '${productHierarchies.join(
        "' or product_hierarchy eq '"
      )}')`
    );
  }

  const searchQuery = filters.join(" and ");
  const request = axios.get(
    process.env.PRODUCT_SEARCH_API_URL + `/CatalogSet?$filter=${searchQuery}`,
    {
      headers: { APIKey: process.env.PRODUCT_SEARCH_API_KEY_ID }
    }
  );
  return request
    .then(response => {
      return Promise.resolve(response.data);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function getSapMaterial(
  salesOrg,
  distributionChannel,
  division,
  productHierarchies,
  materialNo
) {
  return getSearchResults(
    salesOrg,
    distributionChannel,
    division,
    productHierarchies,
    materialNo,
    true
  );
}

export function getSapMaterials(
  salesOrg,
  distributionChannel,
  division,
  productHierarchies,
  materialNo
) {
  return getSearchResults(
    salesOrg,
    distributionChannel,
    division,
    productHierarchies,
    materialNo,
    false
  );
}
